export default "__VITE_ASSET__f7250712__"